export const categories = [
  {
    slug: 'ai-qing-yu-qin-mi',
    name: '爱情与亲密',
    description: '探索爱情中的欲望、亲密关系的深层需求，理解伴侣间的吸引力法则。',
    icon: 'ri-heart-line',
    image: 'https://readdy.ai/api/search-image?query=Two%20silhouettes%20facing%20each%20other%20in%20soft%20twilight%2C%20intimate%20atmosphere%2C%20artistic%20double%20exposure%20effect%2C%20dark%20background%20with%20warm%20amber%20light%20trails%2C%20emotional%20connection%2C%20fine%20art%20photography%20style%2C%20mysterious%20and%20sensual%20mood%2C%20minimalist%20composition&width=800&height=600&seq=cat-love-01&orientation=landscape',
    articleCount: 12,
  },
  {
    slug: 'zi-wo-shi-xian',
    name: '自我实现',
    description: '突破内在限制，释放潜能，在追求卓越的道路上发现欲望的驱动力。',
    icon: 'ri-star-line',
    image: 'https://readdy.ai/api/search-image?query=A%20lone%20figure%20standing%20atop%20a%20mountain%20peak%20at%20dawn%2C%20golden%20light%20breaking%20through%20clouds%2C%20silhouette%20with%20arms%20outstretched%2C%20dramatic%20atmospheric%20lighting%2C%20dark%20moody%20tones%20with%20warm%20highlights%2C%20fine%20art%20landscape%20photography%2C%20inspirational%20and%20contemplative&width=800&height=600&seq=cat-self-01&orientation=landscape',
    articleCount: 8,
  },
  {
    slug: 'shen-ceng-yu-wang',
    name: '深层欲望',
    description: '直面内心最真实的渴望，理解欲望背后的心理机制与情感根源。',
    icon: 'ri-eye-line',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20human%20eye%20with%20galaxy%20and%20cosmos%20reflected%20inside%2C%20deep%20dark%20background%20with%20golden%20light%20particles%2C%20surreal%20artistic%20style%2C%20mysterious%20atmosphere%2C%20introspection%20theme%2C%20high%20contrast%20dramatic%20lighting%2C%20fine%20art%20conceptual%20photography&width=800&height=600&seq=cat-deep-01&orientation=landscape',
    articleCount: 10,
  },
  {
    slug: 'guan-xi-dong-li',
    name: '关系动力',
    description: '解析人际间的欲望流动，理解权力、依赖与吸引的复杂网络。',
    icon: 'ri-links-line',
    image: 'https://readdy.ai/api/search-image?query=Intertwined%20golden%20threads%20and%20light%20lines%20connecting%20in%20darkness%2C%20abstract%20network%20of%20connections%2C%20warm%20amber%20glow%2C%20mysterious%20and%20complex%20web%2C%20artistic%20minimalist%20composition%2C%20dark%20background%2C%20conceptual%20relationship%20visualization&width=800&height=600&seq=cat-rel-01&orientation=landscape',
    articleCount: 7,
  },
  {
    slug: 'qing-gan-tan-suo',
    name: '情感探索',
    description: '深入理解情绪的本质，在情感的迷宫中找到欲望的源头与出口。',
    icon: 'ri-emotion-line',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20flowing%20liquid%20colors%20in%20darkness%2C%20amber%20and%20rose%20tones%20blending%20together%2C%20emotional%20abstract%20art%2C%20fluid%20dynamics%2C%20smooth%20organic%20shapes%2C%20dark%20background%20with%20warm%20light%2C%20contemporary%20fine%20art%20style&width=800&height=600&seq=cat-emotion-01&orientation=landscape',
    articleCount: 9,
  },
  {
    slug: 'shen-xin-he-yi',
    name: '身心合一',
    description: '身体与心灵的和谐统一，通过身心实践唤醒沉睡的欲望能量。',
    icon: 'ri-mental-health-line',
    image: 'https://readdy.ai/api/search-image?query=Human%20silhouette%20meditating%20with%20flowing%20energy%20lines%20and%20golden%20particles%20surrounding%2C%20dark%20atmospheric%20background%2C%20spiritual%20and%20mystical%20vibe%2C%20warm%20amber%20glow%2C%20fine%20art%20photography%2C%20minimalist%20elegant%20composition&width=800&height=600&seq=cat-body-01&orientation=landscape',
    articleCount: 6,
  },
];

export const getAllCategories = () => categories;
export const getCategoryBySlug = (slug: string) => categories.find((c) => c.slug === slug);